import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, HostBinding, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ElementDataRecordView, ElementService, IProcess } from '../../service/element.service';
import { ElementsService, Element } from 'dbweb-core';
import { IconSelectComponent } from '../../../components/icon-select/icon-select.component';
import { MatDialog } from '@angular/material';
import { FormControl } from '@angular/forms';
import { startWith } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
	selector: 'common-processing-lists',
	templateUrl: './processing-lists.component.html',
	styleUrls: ['./processing-lists.component.scss']
})
export class ProcessingListsComponent implements OnInit, OnDestroy {
	@HostBinding('class.processing-lists') hostClass = true;
	public svr = this.elementSvr.data.recordview as ElementDataRecordView;
	ctrlElementName = new FormControl();
	filterElemets: string[];
	private subs: Subscription[] = [];
	constructor(public elementSvr: ElementService, public eles: ElementsService, public dialog: MatDialog) {}
	ngOnDestroy() {
		this.subs.forEach(v => v.unsubscribe());
	}
	ngOnInit() {
		this.subs.push(
			this.svr.currentProcess.subscribe(pro => this.ctrlElementName.patchValue(pro ? pro.ElementName : null)),
			this.svr.inited.subscribe(() => {
				this.subs.push(
					this.ctrlElementName.valueChanges.pipe(startWith('')).subscribe(val => {
						this.filterElemets = this.svr.allElementNames
							.filter(v => v.includes(val))
							.sort((a, b) => a.localeCompare(b));
					}),
					this.ctrlElementName.valueChanges.subscribe(val => {
						if (this.svr.currentProcess.value) {
							this.svr.currentProcess.value.ElementName = val;
						}
					})
				);
			})
		);
	}
	dropBind(event: CdkDragDrop<IProcess[]>) {
		moveItemInArray(this.svr.bindRecordProcesses, event.previousIndex, event.currentIndex);
		this.svr.collectionProcesses();
	}
	dropNotBind(event: CdkDragDrop<IProcess[]>) {
		moveItemInArray(this.svr.notBindRecordProcesses, event.previousIndex, event.currentIndex);
		this.svr.collectionProcesses();
	}

	selectProcess(pro: IProcess) {
		this.svr.currentProcess.next(pro);
	}
	add() {
		const pro = this.svr.currentProcess.value;
		if (pro && pro.BindRecord) {
			this.svr.bindRecordProcesses = this.svr.bindRecordProcesses || [];
			this.svr.bindRecordProcesses.push({
				Name: 'æ°çå¤ç',
				BindRecord: true
			});
		} else {
			this.svr.notBindRecordProcesses = this.svr.notBindRecordProcesses || [];
			this.svr.notBindRecordProcesses.push({
				Name: 'æ°çå¤ç',
				BindRecord: false
			});
		}
		this.svr.collectionProcesses();
	}
	delete() {
		if (this.svr.currentProcess.value) {
			this.svr.Params.Processes.splice(
				this.svr.Params.Processes.findIndex(v => v === this.svr.currentProcess.value),
				1
			);
			if (this.svr.Params.Processes.length > 0) {
				this.svr.currentProcess.next(this.svr.Params.Processes[0]);
			}
			this.svr.refreshProcesses();
		}
	}
	openIconDialog() {
		const pro = this.svr.currentProcess.value;
		if (!pro) {
			return;
		}
		const v = { icon: pro.Icon, color: pro.Color };
		const dialogRef = this.dialog.open(IconSelectComponent, {
			width: '384px',
			height: '100%',
			data: v,
			position: {
				top: '0px',
				right: '0px'
			}
		});
		dialogRef.afterClosed().subscribe(result => {
			if (result) {
				pro.Icon = result.icon;
				pro.Color = result.color;
			}
		});
	}
}
